import type { RootState } from "store";

import { SliceStatus } from "../utils";

export const selectWallet = (state: RootState) => state.wallet;

//This selector shows the loading status of any request done on the wallet store (Generic)
export const selectWalletRequestIsLoading = (state: RootState) =>
  state.wallet.requestStatus === SliceStatus.LOADING;
